export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.21-1240.12",
  commitId: "7dc52363668cb2d5c8ea2d72f37ac5822f4fed54",
  commitTime: "2026-07-21T12:40:12.000Z",
});
